import React from "react";
import PropTypes from "prop-types";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";

import EnhancedTableToolbar from "./EnhancedTableToolbar.js";

import "./css/EnhancedTable.css";

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.dataRows = props.dataRows;
    this.rowsPerPage = 24;

    this.state = {
      dataColumns: props.dataColumns,
      page: 0,
      currentFilter: "ALL",
      currentSearch: "",
    };
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  filterSearch(event) {
    if (
      event !== undefined &&
      event.target !== undefined &&
      event.target.value !== undefined
    ) {
      this.setState({ currentSearch: event.target.value });
    }
  }

  filterSelect(event) {
    if (
      event !== undefined &&
      event.target !== undefined &&
      event.target.value !== undefined
    ) {
      this.setState({ currentFilter: event.target.value });
    }
  }

  accentFold(inStr) {
    return inStr.replace(
      /([àáâãäå])|([çčć])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
      function (str, a, c, e, i, n, o, s, u, y, ae) {
        if (a) return "a";
        if (c) return "c";
        if (e) return "e";
        if (i) return "i";
        if (n) return "n";
        if (o) return "o";
        if (s) return "s";
        if (u) return "u";
        if (y) return "y";
        if (ae) return "ae";
      }
    );
  }

  reCalculateChannels() {
    const currentSearch = this.state.currentSearch;
    const currentFilter = this.state.currentFilter;

    // Search
    var tempRows = this.dataRows;
    if (currentSearch !== "") {
      const toSearch = this.accentFold(currentSearch).toLowerCase();

      tempRows = tempRows.filter((dataRow) => {
        let rowName = this.accentFold(dataRow.name).toLowerCase();
        return rowName.indexOf(toSearch) !== -1;
      });
    }

    // Filter
    if (currentFilter !== "ALL") {
      tempRows = tempRows.filter((dataRow) => {
        return currentFilter === dataRow.category;
      });
    }

    return tempRows;
  }

  render() {
    const { dataColumns, page } = this.state;
    const channelsToDraw = this.reCalculateChannels();

    return (
      <div style={{ height: "100%" }}>
        <EnhancedTableToolbar
          title={this.props.toolbarTitle}
          icon={this.props.toolbarIcon}
        />
        <div style={{ display: "flex", width: "100%" }}>
          <TextField
            id="outlined-basic"
            style={{
              marginLeft: "7px",
              marginBottom: "7px",
              marginRight: "3px",
              width: "95%",
            }}
            margin="dense"
            label="Buscar..."
            variant="outlined"
            onChange={this.filterSearch.bind(this)}
          />
          <FormControl
            variant="outlined"
            style={{
              marginLeft: "3px",
              marginRight: "7px",
              width: "95%",
            }}
            margin="dense"
          >
            <InputLabel>Filtro</InputLabel>
            <Select
              value={this.state.currentFilter}
              onChange={this.filterSelect.bind(this)}
              label="Filtro"
            >
              <MenuItem value="ALL">
                <em>Ningún filtro aplicado</em>
              </MenuItem>
              {this.props.filterValues.map((option, i) => {
                return (
                  <MenuItem key={i} value={option}>
                    {option}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>

        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={channelsToDraw.length}
          rowsPerPage={this.rowsPerPage}
          page={page}
          onChangePage={this.handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from} - ${to} de ${count}`
          }
          style={{
            marginBottom: "5px",
            marginTop: "-5px",
          }}
        />
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {channelsToDraw
            .slice(
              page * this.rowsPerPage,
              page * this.rowsPerPage + this.rowsPerPage
            )
            .map((row, i) => {
              var logo = (
                <img
                  className="img img-logo-channel"
                  src={row[dataColumns[0].id]}
                  alt="logo"
                />
              );

              var name = (
                <p style={{ marginTop: "3px" }}>{row[dataColumns[1].id]}</p>
              );

              return (
                <div
                  className="table-item"
                  style={{ cursor: "pointer" }}
                  key={`${i}#` + row[dataColumns[1].id]}
                  onClick={() => this.props.onClickonRow(row)}
                >
                  {logo}
                  {name}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  toolbarTitle: PropTypes.string.isRequired,
  toolbarIcon: PropTypes.string,
  filterValues: PropTypes.array,
  dataColumns: PropTypes.array.isRequired,
  dataRows: PropTypes.array.isRequired,
  onClickonRow: PropTypes.func,
};

EnhancedTable.defaultProps = {
  toolbarIcon: "",
  dataColumns: {},
  dataRows: {},
  onClickonRow: () => {},
};

export default EnhancedTable;
